/* External */
import mapValues from 'lodash/mapValues';

/* Utils */
import {
  identity,
  deserializeString,
  deserializeNumber,
  deserializeBoolean,
  deserializeDate,
  createShapeDeserializer,
  getShapeDefaultValue,
  TypeDefType,
} from './utils';

export function typedef({
  defaultValue,
  deserializer = identity,
  type = TypeDefType.NATIVE,
  areEqual = null,
}) {
  return {
    isTypeDef: true,
    defaultValue,
    deserializer: (value) => (value ? deserializer(value) : value),
    type,
    areEqual,
  };
}

export function string(defaultValue = '') {
  return typedef({
    defaultValue,
    deserializer: deserializeString,
  });
}

export function number(defaultValue = 0) {
  return typedef({
    defaultValue,
    deserializer: deserializeNumber,
  });
}

export function boolean(defaultValue = false) {
  return typedef({
    defaultValue,
    deserializer: deserializeBoolean,
  });
}

export function date(defaultValue = null) {
  return typedef({
    defaultValue,
    deserializer: deserializeDate,
    areEqual(dateA, dateB) {
      return dateA - dateB === 0;
    },
  });
}

export function shape(shapeDefinition) {
  const deserializer = createShapeDeserializer(shapeDefinition);
  const defaultValue = getShapeDefaultValue(shapeDefinition);

  return typedef({
    defaultValue,
    deserializer,
    type: TypeDefType.SHAPE,
  });
}

export function objectOf(typeDefinition, defaultValue = null) {
  const mapValuesCallback = (value) => typeDefinition.deserializer(value);
  return typedef({
    defaultValue,
    deserializer: (object) => mapValues(object, mapValuesCallback),
    type: TypeDefType.OBJECT,
  });
}

export function arrayOf(typeDefinition, defaultValue = []) {
  const mapCallback = (value) => typeDefinition.deserializer(value);
  return typedef({
    defaultValue,
    deserializer: (array) => array.map(mapCallback),
    type: TypeDefType.ARRAY,
  });
}
